export function loadBingApi() {
    const callbackName = "bingAPIReady";
    let url = `https://www.bing.com/api/maps/mapcontrol?callback=${callbackName}`;

    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.defer = true;
        script.src = url;
        window[callbackName] = () => {
            var ms = window.Microsoft;
            resolve(ms);
        };
        script.onerror = (error: Event) => {
            reject(error);
        };
        document.body.appendChild(script);
    });
}


// WEBPACK FOOTER //
// ./src/api/bingMapsApi.js